<template>
  <input
    @change="onChange"
    type="file"
    id="file"
    name="file"
    accept=".jpg, .jpeg, .png, .webp"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [File, Array, String, FormData],
      required: false,
      default: null,
    },
  },
  methods: {
    async onChange(e) {
      const { files } = e.target;
      const fd = new FormData();
      fd.append("file", files[0]);
      this.$emit("input", fd);
    },
  },
  watch: {
    // если форму сбросили, удаляем прикрепленные файлы
    value(newVal) {
      if (!newVal) {
        this.fileList = [];
      }
    },
  },
};
</script>

<style lang="scss"></style>
